
const summaryStarrating = document.querySelector('.spr-summary-starrating');
const firstChild = summaryStarrating.querySelector('div.spr-starrating > div.spr-stars:nth-child(1)');
const secondChild = document.querySelector('div.spr-starrating > div.spr-stars:nth-child(2)');

const newLink = document.createElement('a');

newLink.addEventListener('click', e => {
   e.preventDefault();
   const targetElement = document.querySelector(newLink.getAttribute('href'));

   if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
   }
});
console.log('yes');
newLink.href = '#shopify-product-reviews';

const writeReviewButton = document.createElement('div');

writeReviewButton.innerHTML = `
  <a href="#shopify-product-reviews">
    <span class="underline-hover">Write a review</span>
  </a>
`;

const anchorElement = writeReviewButton.querySelector('a');
anchorElement.addEventListener('click', e => {
   e.preventDefault();
   const targetElement = document.querySelector(anchorElement.getAttribute('href'));

   if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
   }
});

summaryStarrating.appendChild(writeReviewButton)
summaryStarrating.style.alignItems = 'start'

if (firstChild) {
   firstChild.parentNode.insertBefore(newLink, firstChild);
   newLink.appendChild(firstChild);
}
if (secondChild && secondChild.innerHTML.trim() === '') {
   summaryStarrating.removeChild(secondChild);
   writeReviewButton.style.paddingLeft = '0px'
} else {
   writeReviewButton.style.paddingLeft = '5px'
}
